import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgContribution = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#e58181",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1.5,
			width: 14,
			height: 13,
			rx: 1,
			fill: "currentColor",
			fillOpacity: .25,
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99992 10.5667L7.99992 5.43332",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.13335 7.30005L8.00001 5.43338L9.86668 7.30005",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgContribution;
